import { Agent, MerchantStructure } from '@nemuru-eng/js-api-client';
import React, { Dispatch, SetStateAction } from 'react';
import { SWRConfig } from 'swr';

import { ChangeToAnotherChannelMessage } from '@/components/widgets/AgentDetailActions/components/ChangeToAnotherChannelMessage';
import { CloneType } from '@/components/widgets/AgentDetailActions/components/CloneAgent/types/CloneType';
import { AgentDetailAction } from '@/components/widgets/AgentDetailActions/types/AgentDetailAction';

import { CloneAgent } from './CloneAgent/CloneAgent';

export const AgentDetailDialog: React.FC<{
  agent?: Agent;
  merchantStructure?: MerchantStructure;
  currentAction: AgentDetailAction;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
}> = ({ agent, merchantStructure, currentAction, opened, setOpened, toggleDialog }) => {
  if (!agent || !merchantStructure) return null;
  return (
    <>
      <SWRConfig value={{ revalidateOnMount: false }}>
        {currentAction === AgentDetailAction.CHANGE_TO_ANOTHER_CHANNEL && (
          <ChangeToAnotherChannelMessage
            agent={agent}
            merchantStructure={merchantStructure}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {currentAction === AgentDetailAction.CLONE_AGENT && (
          <CloneAgent
            type={CloneType.CLONE}
            clonedAgent={agent}
            merchantStructure={merchantStructure}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {currentAction === AgentDetailAction.UPDATE_AGENT && (
          <CloneAgent
            type={CloneType.UPDATE}
            clonedAgent={agent}
            merchantStructure={merchantStructure}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
      </SWRConfig>
    </>
  );
};
